"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.HotelData = void 0;
var _propTypes = require("prop-types");
var _constant = require("../Theme/constant");
var HotelData = {
  actions: _propTypes.array,
  columns: (0, _propTypes.shape)({
    date: _propTypes.string,
    hotel: (0, _propTypes.shape)({
      name: _propTypes.string,
      icon: (0, _propTypes.shape)({
        name: _propTypes.string,
        fontSize: _propTypes.string
      }),
      location: _propTypes.string,
      locationIcon: (0, _propTypes.shape)({
        name: _propTypes.string,
        fontSize: _propTypes.string
      })
    }),
    orderNumber: (0, _propTypes.shape)({
      key: _propTypes.string,
      value: _propTypes.string
    }),
    checkIn: (0, _propTypes.shape)({
      key: _propTypes.string,
      value: _propTypes.string
    }),
    checkOut: (0, _propTypes.shape)({
      key: _propTypes.string,
      value: _propTypes.string
    }),
    status: (0, _propTypes.shape)({
      value: _propTypes.string,
      fontColor: _propTypes.string
    }),
    icon: (0, _propTypes.shape)({
      name: _propTypes.string,
      fontSize: _propTypes.string
    })
  }),
  bottomBorder: _propTypes.bool,
  hideDate: _propTypes.bool
};
exports.HotelData = HotelData;
var _default = {
  PropTypes: {
    theme: _propTypes.string,
    accessible: _propTypes.bool,
    isMobile: _propTypes.bool,
    translation: _propTypes.object,
    data: (0, _propTypes.shape)(HotelData),
    handleClick: _propTypes.func,
    pastJourney: _propTypes.bool
  },
  DefaultProps: {
    theme: _constant.DEFAULT_THEME,
    accessible: true,
    isMobile: true,
    translation: null,
    data: {
      actions: [],
      columns: null,
      bottomBorder: false,
      hideDate: false
    },
    handleClick: function ref() {},
    pastJourney: false
  }
};
exports.default = _default;